import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const OfflinePage = lazy(() => import('./OfflinePage'));

const OfflinePageConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: 'offline',
      element: <OfflinePage />,
    },
  ],
};

export default OfflinePageConfig;